/**
 * Which of the member's own bank accounts each money path may use.
 *
 * The two paths are deliberately asymmetric, and the asymmetry lives here so a
 * change to one cannot silently become a change to both.
 *
 * A DEPOSIT's bank account is the account the player says they transferred
 * FROM. The money arrives at a house account; svc-finance stores the id on
 * `member_bank_account_id` and nothing ever resolves it, and POST /deposits has
 * no verification check of its own. Filtering to verified accounts therefore
 * refused nothing but the player: a member who signed up minutes ago has an
 * unverified account by construction and could not fund the wallet at all until
 * an operator got round to them.
 *
 * A WITHDRAWAL's bank account is where money is SENT. `verified` is
 * operator-settable and is frozen onto the withdraw row as a snapshot, so that
 * path keeps its filter.
 */
export interface EligibilityBankAccount {
  verified: boolean;
}

/** Every account the member holds — a deposit needs no operator verification. */
export function depositSourceBanks<T extends EligibilityBankAccount>(banks: readonly T[]): T[] {
  return [...banks];
}

/** Verified accounts only — a payout destination is checked before money moves. */
export function withdrawDestinationBanks<T extends EligibilityBankAccount>(
  banks: readonly T[],
): T[] {
  return banks.filter((b) => b.verified);
}
